import BecomeAMember from './BecomeAMember';

export default BecomeAMember;
